import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { QuestionType } from "../../entities/question-type";

@Injectable()
export class QuestionTypeRepo extends Repository<QuestionType>{
    constructor(private dataSource: DataSource) {
        super(QuestionType, dataSource.createEntityManager());
    }
}